import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTimes, faPlus, faCheck } from "@fortawesome/free-solid-svg-icons";
import "../styles/TabNavigation.css";

const TabNavigation = ({
  tabs,
  selectedTabId,
  setSelectedTabId,
  addTab,
  renameTab,
  deleteTab,
}) => {
  const [editingId, setEditingId] = useState(null);
  const [draft, setDraft] = useState("");

  const startEdit = (tab) => {
    setEditingId(tab.id);
    setDraft(tab.title);
  };

  const commitEdit = () => {
    if (editingId) renameTab(editingId, draft);
    setEditingId(null);
  };

  const cancelEdit = () => setEditingId(null);

  return (
    <div className="db-tab-nav">
      {tabs.map((tab) => {
        const isActive = selectedTabId === tab.id;
        const isEditing = editingId === tab.id;
        return (
          <div
            key={tab.id}
            className={`tab-chip ${isActive ? "tab-chip--active" : ""} ${isEditing ? "tab-chip--editing" : ""}`}
          >
            {isEditing ? (
              <input
                className="tab-chip-input"
                value={draft}
                autoFocus
                onChange={(e) => setDraft(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                onBlur={commitEdit}
                onKeyDown={(e) => {
                  if (e.key === "Enter") commitEdit();
                  if (e.key === "Escape") cancelEdit();
                }}
              />
            ) : (
              <button
                className="tab-chip-label"
                onClick={() => setSelectedTabId(tab.id)}
                title={tab.title}
              >
                {tab.title}
              </button>
            )}

            <span className="tab-chip-divider" aria-hidden="true" />

            <span className="tab-chip-actions">
              {isEditing ? (
                <button
                  className="tab-chip-icon-btn tab-chip-icon-btn--confirm"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={commitEdit}
                  title="Save name"
                >
                  <FontAwesomeIcon icon={faCheck} />
                </button>
              ) : (
                <>
                  <button
                    className="tab-chip-icon-btn"
                    onClick={() => startEdit(tab)}
                    title="Rename tab"
                  >
                    <FontAwesomeIcon icon={faPen} />
                  </button>
                  {tabs.length > 1 && (
                    <button
                      className="tab-chip-icon-btn tab-chip-icon-btn--danger"
                      onClick={(e) => { e.stopPropagation(); deleteTab(tab.id); }}
                      title="Delete tab"
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}
                </>
              )}
            </span>
          </div>
        );
      })}

      <button className="tab-add-btn" onClick={addTab} title="Add a new tab">
        <FontAwesomeIcon icon={faPlus} /> Add Tab
      </button>
    </div>
  );
};

export default TabNavigation;
